import { RootState, useAppSelector } from '@core/store';
import { BANNER_HEIGHT } from '@features/dynamic-components/components/banner/constants';

import { NAVBAR_HEIGHT } from '../constants';
import useTopBannersOffset from './useTopBannersOffset';

const useContentTopOffset = () => {
  const bannerCount = useAppSelector(
    (state: RootState) =>
      state.dynamicComponents.banners.length +
      state.dynamicComponents.feStaticBanners.length
  );
  const { total: topBannersOffset } = useTopBannersOffset();

  const bannerOffset = bannerCount > 0 ? BANNER_HEIGHT : 0;

  return topBannersOffset + NAVBAR_HEIGHT + bannerOffset;
};

export default useContentTopOffset;
